
import {DataForm} from 'argo-js/src/view';

export class EmailChange extends DataForm {

  constructor(config) {
    super($.extend({
      ui: {
        statusMessage: '.status-message',
        successText: '.alert-success'
      },
      errorMap: {
        PASSWORD_DOES_NOT_MATCH: {
          name: 'password',
          message: 'error.PASSWORD_DOES_NOT_MATCH'
        },
        MESSAGE_COULD_NOT_BE_SENT: {
          name: 'email',
          message: 'error.MESSAGE_COULD_NOT_BE_SENT'
        },
        INVALID_EMAIL_ADDRESS: {
          name: 'email',
          message: 'error.INVALID_EMAIL_ADDRESS'
        },
        EMAIL_MUST_NOT_BE_EQUAL_TO_OLD_EMAIL: {
          name: 'email',
          message: 'error.EMAIL_MUST_NOT_BE_EQUAL_TO_OLD_EMAIL'
        },
        USER_EMAIL_DISABLED: {
          message: 'error.USER_EMAIL_DISABLED'
        }
      }
    }, config));
  }

  onSubmit(data) {
    return this.app.user.requestChangeEmailAddress(data.email, data.password);
  }

  onSuccess() {
    this.ui.successText.text(this.t('changeEmailModal.success'));
    this.ui.form.hide();
    this.ui.statusMessage.fadeIn(500);
  }

  onReturnToReferer() {
    this.app.redirect(this.app.config.referrerUrl);
  }
}

